<template>
  <div
    v-loading="loading"
    class="bookList"
    element-loading-text="正在拉取图书数据"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <ComponentsList ref="componentsList" :props-columns="columns" :props-data="propsData" :search-form="searchForm" @editLinkType="editLinkTypeHandle">
      <module-title title="">
        <div class="right">
          <el-button
            type="primary"
            size="medium"
            @click="updateBookHandle"
          >
            更新书包图书
          </el-button>
          <el-button
            type="primary"
            size="medium"
            @click="editLinkTypeHandle"
          >
            关联分类
          </el-button>
          <el-button
            type="primary"
            size="medium"
            @click="handleDialogFree"
          >
            添加到免费专区
          </el-button>
        </div>
      </module-title>
      <el-form
        ref="searchForm"
        :model="searchForm"
        :inline="true"
        label-position="right"
        label-width="120px"
      >
        <el-form-item label="图书编码" prop="bookCode">
          <el-input
            v-model="searchForm.bookCode"
            name="bookCode"
            placeholder="请输入图书编码"
            class="edit-form-input"
            maxlength="50"
            clearable
          />
        </el-form-item>
        <el-form-item label="是否限免：" prop="isLimitFree">
          <el-select
            v-model="searchForm.isLimitFree"
            style="width: 110px;"
          >
            <el-option label="全部" value="" />
            <el-option label="是" value="1" />
            <el-option label="否" value="0" />
          </el-select>
        </el-form-item>
        <el-form-item label="名称" prop="bookName">
          <el-input
            v-model="searchForm.bookName"
            name="bookName"
            placeholder="请输入图书名称"
            class="edit-form-input"
            maxlength="50"
            clearable
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            size="medium"
            icon="el-icon-search"
            @click="handleSearchFilter"
          >
            查询
          </el-button>
        </el-form-item>
      </el-form>
    </ComponentsList>
    <el-dialog
      v-if="handleFormAdd.dialogAddVisible"
      :close-on-click-modal="false"
      :visible.sync="handleFormAdd.dialogAddVisible"
      title="关联分类"
      width="600px"
    >
      <el-tree
        ref="bookTypesTyee"
        :check-strictly="checkStrictly"
        :data="apptypesTree"
        :props="defaultProps"
        :default-checked-keys="defaultKeys"
        default-expand-all
        show-checkbox
        node-key="id"
      >
        <span slot-scope="{ node }" class="custom-tree-node" :title="node.label">
          {{ node.label }}
        </span>
      </el-tree>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="handleFormAdd.dialogAddVisible = false">
          取消
        </el-button>
        <el-button
          :loading="ajaxLoading"
          type="primary"
          size="medium"
          @click="handleBookLinkType"
        >
          {{ ajaxLoading?'Loading':'确定' }}
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      v-if="handleFormFreed.dialogFreeVisible"
      :close-on-click-modal="false"
      :visible.sync="handleFormFreed.dialogFreeVisible"
      title="添加专区"
      width="600px"
    >
      <div>
        <el-checkbox-group v-model="handleFormFreed.checkList">
          <div v-for="v in propsData.checkShowList" :key="v.label" class="checkboxItem">
            <el-checkbox :label="v.label">
              {{ v.value }}
            </el-checkbox>
          </div>
        </el-checkbox-group>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="handleFormFreed.dialogFreeVisible = false">
          取消
        </el-button>
        <el-button
          :loading="ajaxLoading"
          type="primary"
          size="medium"
          @click="handleBookLimitFree"
        >
          {{ ajaxLoading?'Loading':'确定' }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import EllaRentBooks from '@/api/userManagement/ellaRentBooks';
import ComponentsList from '@/views/financialCenter/ellaRentBooks/common/componentsList';
import { columnsBookList } from '@/views/financialCenter/ellaRentBooks/common/columns';

export default {
  name: 'BookList',
  components: { ComponentsList },
  data() {
    return {
      checkStrictly: false,
      ajaxLoading: false,
      loading: false,
      defaultKeys: [],
      searchForm: {
        bookCode: '',
        isLimitFree: '',
        pageNum: 1,
        total: 0,
        pageSize: 10
      },
      propsData: {
        tree: true,
        unautoLoading: true,
        treeApi: 'get_types_tree',
        api: 'get_books_pageList',
        checkShowList: [
          { label: 1, value: '限免专区' },
          { label: 2, value: '安全教育专区' },
          { label: 3, value: '品格素养专区' },
          { label: 4, value: '有声识字专区' },
          { label: 5, value: '绘画天地专区' }
        ]
      },
      handleFormAdd: {
        dialogAddVisible: false,
        type: 'add',
        id: ''
      },
      handleFormFreed: {
        dialogFreeVisible: false,
        checkList: []
      }
    };
  },
  computed: {
    columns() {
      return columnsBookList;
    },
    apptypesTree() {
      return this.$store.state.ella.apptypesTree;
    },
    defaultProps() {
      return this.$refs.componentsList.defaultProps;
    },
    multipleSelection() {
      return this.$refs.componentsList.multipleSelection;
    }
  },
  methods: {
    // 关联分类
    editLinkTypeHandle(val) {
      this.defaultKeys = [];
      if (this.multipleSelection.length <= 0 && !val.id) {
        this.$message.error('选择关联分类图书！');
        return;
      }
      if (val.id) {
        this.handleFormAdd.type = 'edit';
        this.handleFormAdd.id = val.id;
        const types = [];
        if (val.types && val.types.length > 0) {
          val.types.forEach(element => {
            types.push(element.secondTypeId);
          });
          this.defaultKeys = [...new Set(types)];
        } else { this.defaultKeys = []; }
      } else {
        this.handleFormAdd.type = 'add';
      }
      this.handleFormAdd.dialogAddVisible = true;
    },
    // 条件查询
    handleSearchFilter() {
      this.searchForm.pageNum = 1;
      this.$refs.componentsList.fetchdataList();
    },
    // 重置
    handleSearchReset() {
      this.searchForm = {
        bookCode: '',
        isLimitFree: '',
        pageNum: 1,
        total: 0,
        pageSize: 10
      };
    },
    // 更新图书包
    updateBookHandle() {
      const _self = this;
      this.loading = true;
      EllaRentBooks['get_books_update_bag']().then((res) => {
        if (res.code === '0') {
          const timeInterval = setInterval(function() {
            EllaRentBooks['get_books_update_bag_status']().then((res) => {
              if (res.code === '0') {
                if (res.data.status > 1) {
                  _self.loading = false;
                  _self.$store.dispatch('fetchAppBooKtypesTree').then(() => {
                    _self.$refs.componentsList.fetchdataList();
                  });
                  clearInterval(timeInterval);
                }
              }
            });
          }, 1000);
        }
      });
    },
    // 添加关联分类
    handleBookLinkType() {
      this.ajaxLoading = true;
      const treeObj = this.$refs.bookTypesTyee;
      const checkedList = treeObj.getCheckedNodes();
      const bookTypeIds = checkedList.filter(x => !x.children).map(v => v.id);
      let bookIds = '';
      if (this.handleFormAdd.type === 'add') {
        bookIds = this.multipleSelection.map(x => x.id);
      } else {
        bookIds = [this.handleFormAdd.id];
      }
      const op = {
        bookIds,
        bookTypeIds
      };
      EllaRentBooks['get_booksLinkType_pageList'](op).then((res) => {
        if (res.code === '0') {
          this.handleFormAdd.dialogAddVisible = false;
          this.$message.success('操作成功');
          this.$refs.componentsList.fetchdataList();
        }
        this.ajaxLoading = false;
      }).catch(err => {
        console.log(err);
        this.ajaxLoading = false;
      });
    },
    handleDialogFree() {
      this.handleFormFreed.checkList = [];
      this.handleFormFreed.dialogFreeVisible = true;
    },
    // 添加限免
    handleBookLimitFree() {
      if (this.multipleSelection.length <= 0) {
        this.$message.error('请选择添加限免图书！');
        return;
      }
      if (this.handleFormFreed.checkList <= 0) {
        this.$message.error('请选择添加专区！');
        return;
      }
      const status = this.handleFormFreed.checkList;
      const bookIds = this.multipleSelection.map(x => x.id);
      EllaRentBooks['get_books_limit_free']({ ids: bookIds, limitFreeAreas: status }).then((res) => {
        if (res.code === '0') {
          this.handleFormAdd.dialogAddVisible = false;
          this.$message.success('配置成功');
          this.$refs.componentsList.fetchdataList();
          this.handleFormFreed.dialogFreeVisible = false;
        }
      }).catch(err => {
        console.log(err);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.edit-form-select{width: 100px;}
.checkboxItem{margin-left: 50px; margin-top: 10px;}
</style>
